import { BULK_DELETE_MAX_IDS, type BulkDeleteResult } from '@carrierbridge/shared';
import api from '@/lib/api';

/**
 * Appelle `POST /:resource/bulk-delete` en découpant la sélection en lots que
 * l'API accepte.
 *
 * L'écran Data propose « sélectionner les N lignes filtrées » : sur un
 * référentiel de plusieurs milliers de lignes, un seul corps de requête
 * dépasserait la borne du DTO et l'utilisateur récolterait un 400 sur
 * exactement le geste que la fonctionnalité met en avant. Les lots partent
 * séquentiellement — le serveur supprime réellement à chaque appel, et les
 * paralléliser ne ferait que multiplier les transactions concurrentes sur les
 * mêmes tables pour gagner quelques centaines de millisecondes.
 *
 * Les rapports partiels sont concaténés : l'appelant voit le total supprimé et
 * la liste complète des lignes qui ont résisté, quel que soit le découpage.
 */
export async function bulkDeleteInBatches(
  resource: string,
  ids: string[],
): Promise<BulkDeleteResult> {
  const merged: BulkDeleteResult = { deleted: 0, failed: [] };

  for (let i = 0; i < ids.length; i += BULK_DELETE_MAX_IDS) {
    const batch = ids.slice(i, i + BULK_DELETE_MAX_IDS);
    const { data } = await api.post<BulkDeleteResult>(`${resource}/bulk-delete`, { ids: batch });
    merged.deleted += data.deleted;
    merged.failed.push(...data.failed);
  }

  return merged;
}
